import {
  makeRequired,
  makeStringPhoneNumber,
  stringValidator,
} from '../../../../../OUI/Inputs';

export const usernameFieldValidator = makeRequired(makeStringPhoneNumber(stringValidator));
